import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'
import Vue from 'vue'

export const bugsnagClient = bugsnag({
    apiKey: '7359d0738bcf3014370777f0af98874f',
    appVersion: window.App.version
})
export const setupBugsnag = function() {
    bugsnagClient.use(bugsnagVue, Vue)
}
